import React, { useState } from "react";
import "./Education.css";
import educationImg from "../../img/education.jpg";
import heritageImg from "../../img/heritage.jpg";
import goalImg from "../../img/goal.png";
import aboutHeroImage from '../../img/about-us-banner.jpg'; // Replace with the correct image path
import Footer from "../home-page/Footer";


const Education = () => {
  const [activeSection, setActiveSection] = useState("education");

  const sections = [
    {
      id: "education",
      title: "1. Education & Awareness",
      content: (
        <>
          <h2>Education & Awareness</h2>
          <p className="awarness-p">
            Our programs inspire creativity and foster appreciation for cultural traditions. From hands-on workshops to engaging lectures, we focus on blending heritage with modern design thinking.
          </p>
          <ul>
            <li>🎨 Creative Workshops</li>
            <li>🌍 Global Collaborations</li>
            <li>🖋️ Heritage Design Thinking</li>
          </ul>
        </>
      ),
      image: educationImg,
    },
    {
      id: "heritage",
      title: "2. Heritage Workshops",
      content: (
        <>
          <h2>Heritage Workshops</h2>
          <p>
            Our heritage workshops provide immersive learning experiences by blending traditional motifs with contemporary aesthetics.
          </p>
          <ul>
            <li>🌟 Exploring traditional crafts like weaving, pottery, and painting</li>
            {/* <li>🌟 Collaborating with artisans and cultural experts</li> */}
            <li>🌟 Integrating heritage principles into modern design projects</li>
            {/* <li>🌟 Virtual and in-person sustainability sessions</li> */}
          </ul>
        </>
      ),
      image: heritageImg,
    },
    {
      id: "goals",
      title: "3. Our Future Vision",
      content: (
        <>
          <h2>Our Future Vision</h2>
          <p>
            We aim to create a global network of education and collaboration, leveraging the digital medium to connect people across borders.
          </p>
          <ul>
            <li>📚 Expanding virtual workshops for global accessibility</li>
            <li>🌱 Promoting sustainable practices in education</li>
            {/* <li>🎯 Building partnerships with educational institutions worldwide</li> */}
            <li>💡 Developing a resource hub for cultural preservation projects</li>
          </ul>
        </>
      ),
      image: goalImg,
    },
  ];

  return (
    <>
    <div className="about-hero-section">
        <img src={aboutHeroImage} alt="About Us" className="about-hero-image" />
        <div className="about-hero-overlay"></div>
        <div className="about-hero-content">
          <h1>Explore</h1>
          <div className="breadcrumb">
            <span>Explore</span> &gt; <span>Education & Awareness</span>
          </div>
        </div>
      </div>
    <div className="education-page">
      {/* Header Section (Top of Entire Layout) */}
      <div className="education-header">
        <h1 className="education-title">Empowering Through Education</h1>
        <p className="education-description">
          Bridging the gap between heritage and modernity through impactful learning experiences.
        </p>
        <div className="horizontal-line"></div>
      </div>

      {/* Main Content */}
      <div className="education-container">
        {/* Left Section */}
        <div className="education-headings">
          {sections.map((section) => (
            <div
              key={section.id}
              className={`heading-item ${activeSection === section.id ? "active" : ""}`}
              onClick={() => setActiveSection(section.id)}
            >
              {section.title}
            </div>
          ))}
        </div>

        {/* Vertical Divider */}
        <div className="vertical-divider"></div>

        {/* Right Section */}
        <div className="education-content">
          {sections
            .filter((section) => section.id === activeSection)
            .map((section) => (
              <div key={section.id} className="content-section">
                <img src={section.image} alt={section.id} className="content-image" />
                <div className="content-text">{section.content}</div>
              </div>
            ))}
        </div>
      </div>

      {/* Impact Section */}
      <div className="impact-section">
        <h2 className="impact-title">The Impact of Education</h2>
        <p className="impact-description">
          Education serves as the cornerstone for societal progress and personal growth. Here's how we make a difference:
        </p>
        <ul className="impact-list">
          <li className="impact-item">🌍 Empowering individuals through global collaborations</li>
          <li className="impact-item">📘 Promoting lifelong learning and skill development</li>
          <li className="impact-item">💡 Fostering innovation by bridging tradition and modernity</li>
        </ul>
      </div>
    </div>
    <Footer/>
    </>
  );
};

export default Education;